import { render, staticRenderFns } from "./Reporting_TH.vue?vue&type=template&id=7c287c18"
import script from "./Reporting_TH.vue?vue&type=script&lang=js"
export * from "./Reporting_TH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports